import * as React from "react";
import { FormEvent, useEffect } from "react";
import Button from "@components/common/button/Button";
import { withStyles, WithStyles } from '@material-ui/core/styles';
import TranslateNew from "@translate/TranslateNew";
import Input from "@components/common/input/input.component";
import {Typography} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CornerRightElements2 from "@components/svg/cornerRightElements2";
import { ForgotPasswordStyle } from "@components/forgot-password/forgot-password.style";
import SelectLanguage from "@components/common/language/SelectLanguage";
import { Link } from "react-router-dom";
import { getOS } from '@helpers/osDetection';

const tn: TranslateNew = TranslateNew.getInstance();
const os = getOS();

interface IForgotPasswordProps extends WithStyles<typeof ForgotPasswordStyle> {
    onSubmit: (values: any) => void;
}

interface IState {
    hasSubmitted: boolean;
    formValues: {
        email: string,
    };
    formErrors: {
        email?: string | undefined,
    };
}


class ForgotPassword extends React.Component<IForgotPasswordProps, IState> {
    constructor(props: IForgotPasswordProps) {
        super(props);

        this.state = {
            hasSubmitted: false,
            formValues: {
                email: "",
            }, formErrors: {
                email: undefined,
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
    }

    public successCallback() {
        console.log("success");
    };

    public errorCallback(errMsg: any) {
        console.log("Error! " + errMsg);
    }

    public render() {
        const { formErrors, formValues, hasSubmitted } = this.state;
        const style = this.props.classes;

        return (<div className={style.root}>
            <div className={style.background}>
                <div className={style.circle} />
                <CornerRightElements2 viewBox="-40 10 219 212" className={style.backgroundImgCornerTopRight} />
            </div>
            <div className={style.languageSelect}>
                <SelectLanguage />
            </div>
            <div className={style.container}>
                <div className={style.topBar}>
                    <Link to='/' style={{ textDecoration: 'none' }}>
                        <Button variant="text" className={style.backButton}>
                            <ArrowBackIcon fontSize="inherit" />
                            <span>{tn.lang.back}</span>
                        </Button>
                    </Link>
                </div>
                <div className={style.centerContent}>
                    <div className={style.topContent}>
                        <Typography variant="h2">{tn.lang.logInForgot}</Typography>
                        <Typography>{hasSubmitted ? tn.lang.magicTokenTitle : tn.lang.magicTokenBody}</Typography>
                        {(hasSubmitted && (os === 'IOS' || os === 'ANDROID')) &&
                            <div className={style.formBottomContent}>
                                <a href={"mailto:?subject=Hello&body=This was just to open the mail-app, now check your inbox"} 
                                    style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        size="large">
                                        {tn.lang.openApp}
                                    </Button>
                                </a>
                            </div>}
                    </div>
                    {!hasSubmitted && (
                        <form className={style.form} onSubmit={this.handleSubmit}>
                            <div className={style.formMiddleContent}>
                                <Input
                                    type="text"
                                    name="email"
                                    id="email"
                                    label={tn.lang.labelEmail}
                                    autoComplete="email"
                                    value={formValues.email}
                                    onChange={this.handleInputChange}
                                    onBlur={this.handleInputBlur}
                                    error={formErrors.email}
                                />
                            </div>

                            <div className={style.formBottomContent}>
                                <Button
                                    type="submit"
                                    variant='contained'
                                    color='primary'
                                    size="large"
                                    fullWidth={true}
                                >
                                    {tn.lang.submitMagicLink}
                                </Button>

                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div >);
    }

    private validateEmail = (): boolean => {
        const { formValues } = this.state;
        if (!formValues.email) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, email: tn.lang.validationEmailRequired,
                },
            }));
            return false;
        } else if (!tn.testEmailIsValid(formValues.email)) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, email: tn.lang.validationEmailNotValid,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors, email: undefined,
            },
        }));
        return true;
    }

    private handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const isEmailValid = this.validateEmail();

        if (isEmailValid) {
            this.props.onSubmit(this.state.formValues);
            this.setState({ hasSubmitted: true });
        }
    }

    private handleInputBlur = (event: React.FormEvent<HTMLInputElement>) => {
        const { name } = event.currentTarget;

        switch (name) {
            case 'email':
                this.validateEmail();
                break;
        }
    }

    // Update form values in state when inputs change
    private handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            formValues: {
                ...prevState.formValues,
                [name]: value,
            },
            formErrors: {
                ...prevState.formErrors,
                [name]: undefined,
            },
        }));
    }
}

export default withStyles(ForgotPasswordStyle)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/forgot-password/forgot-password.component.tsx